var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconGitlab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "gitlab") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gitlab",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-gitlab",
    transform: "translate(-0.000000, 1.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.39604952,8.50530046 L12.000013,22.2856999 L0.378487527,13.660001 C0.0571126869,13.4189699 -0.0767622465,13.0039388 0.0437533186,12.6290797 L1.39604952,8.50530046 Z M4.93065714,0.311273283 C4.78337596,-0.103757761 4.19429813,-0.103757761 4.04701695,0.311273283 L1.39604952,8.50530046 L7.58171832,8.50530046 L4.93065714,0.311273283 Z M7.58171832,8.50530046 L12.000013,22.2856999 L16.4183077,8.50530046 L7.58171832,8.50530046 Z M23.9562727,12.6290797 L22.6039765,8.50530046 L12.000013,22.2856999 L23.6215385,13.660001 C23.9428664,13.4189699 24.0767414,13.0039388 23.9562727,12.6290797 Z M19.9529622,0.311273283 C19.805681,-0.103757761 19.2166032,-0.103757761 19.069322,0.311273283 L16.4183077,8.50530046 L22.6039765,8.50530046 L19.9529622,0.311273283 L19.9529622,0.311273283 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGitlab);
export default __webpack_public_path__ + "static/media/icon-gitlab.ca73a91811151fa0b78f2874fb368f2f.svg";
export { ForwardRef as ReactComponent };